import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'contracts',
    loadChildren: () => import('@ruby/modules/third-party/submodules/third-grid/third-party-grid.module').then(m => m.ThirdPartyGridModule)
  },
  {
    path: 'authorization',
    loadChildren: () => import('@ruby/modules/third-party/submodules/third-contract/third-party-contract.module').then(m => m.ThirdPartyContractModule)
  },
  {
    path: '',
    redirectTo: 'contracts',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ThirdPartyRoutingModule {}
